import Hero from '../ckan/Herov2';
import Highlight from '../solutions/Highlight.jsx'
import ValuePropositions from '../ckan/ValuePropositions.jsx'
import Blog from '../ckan/Blog'
import SocialProof from '../ckan/SocialProof';
import CaseStudiesSection from '../solutions/CaseStudiesSection';
import Link from 'next/link';

export default function DataCatalog({blogs, casestudies}) {
  const values= [
    {
      title: "Find your data with ease",
      text: "With all your data discoverable in one place, you can efficiently locate and access relevant data and avoid duplication.",
    },
      {
      title: "Standardize metadata for powerful insights",
      text: "Build up context around your data so you have all the information you need. Ensure consistent and meaningful insights for informed decision-making.",
    },
      {
      title: "Evolve to a data management system",
      text: "Easily expand your Data Catalog with storage, APIs, enrichment, visualizations, and more, as your organization grows and evolves.",
    },
    {
      title: "Seamless data integration & interoperability",
      text: "Effortlessly connect and consolidate data from diverse sources, enabling holistic analysis and insights.",
    },
    {
      title: "Robust data governance & compliance",
      text: "Enhance data security and maintain compliance with industry standards, protecting your organization and its data.",
    },
    {
      title: "Empower collaboration & data sharing",
      text: "Foster cross-functional collaboration and data sharing, driving synergy and maximizing your data's potential",
    },
  ]

  return (
    <section className="bg-homeExpert bg-no-repeat bypass-filter bg-catalogPosition"
    >
      <section>
        <Hero topTitle="Data Catalogs" title="A single point of data discovery. Because you can’t use what you can’t find." subtitle="Tired of manually sending files round the office? Tell Simon he can find the document he’s looking for in your new data catalog." />
      </section>

      <section className='pt-8'>
        <SocialProof />
      </section>
      
      <section className=' relative w-screen max-w-screen overflow-hidden lg:flex-row bg-gradient-to-b from-transparent to-[#F7F8F9]'>
          <Highlight subtitle="EMPOWER YOUR DATA JOURNEY " topTitle="Build your data catalog with us"
            text="Gone are the days when collecting and analyzing data was limited to the IT department. Today, working with data is a business-as-usual activity for all kinds of staff, from HR and finance to marketing and business development. Our products offer a fit-for-purpose solution to the problem of internal data management, ensuring that data is usable and used by all relevant stakeholders across your company."
           />
      </section>

      <section className='mt-36'>
        <ValuePropositions topTitle="It all starts with a data catalog" title="An all-in-one solution that seamlessly bridges data from various sources. Launch your data catalog journey and unleash the untapped value hidden within your data." valuePropositions={values}/>
      </section>

      <section>
        <CaseStudiesSection blogs={casestudies} subtitle="DATA CATALOG" catalog="data" />
      </section>

      <section className='bg-[#F7F8F9] py-20 relative w-screen max-w-screen overflow-hidden' tabIndex={0}>
        <h3 className='text-center mx-auto medium-title font-["Inter"] text-maingray' >Data Management is complex. We make it easy.</h3>
        <p className='text-center font-["Inter"] text-maingray mt-4 px-8 sm:px-0 mx-auto xl:max-w-4xl lg:max-w-3xl md:max-w-2xl max-w-sm'>Get the answers you need today. Join thousands of happy customers.</p>
        <div className='flex flex-col sm:flex-row mt-8 gap-y-8 sm:gap-x-8 w-full justify-center px-8 sm:px-0 mx-auto xl:max-w-4xl lg:max-w-3xl md:max-w-2xl max-w-sm'>
         <div className='btn-primary'><Link href="/contact">Email us</Link></div>
        <div className='btn-primary'><Link href="https://calendar.app.google/LT4acVdKn3Cxm2MXA" target="_blank">Schedule a free call</Link></div>
        </div>
      </section>

      <section className='mt-14'>
        <Blog blogs={blogs} />
      </section>

    </section>
  );
}
